export default {
    "401" : "You must be logged in to complete this action.",
    "403" : "You are not permitted to complete this action.",
    "408" : "There was a problem retrieving content. Please refresh your page and try again.",
    "429" : "You have exceeded the permitted attempts. Please try again later.",
    "422" : "This user identifier is invalid.",
    "No_Response" : "There was a problem retrieving content. Please refresh your page and try again.",
    "server_error" : "There was a problem retrieving content. Please refresh your page and try again.",
    "unknown" : "Oops, something went wrong. Please refresh your page and try again."
}